import { APPLY_PRESET_VIEW } from '@src/utils/presets/personalPresets';
import update from 'immutability-helper';
import { Widget } from '@components/top-widget-panel/spi-panel/widgets/constants';
import { DEFAULT_WIDGETS, SUMMARY_PANEL_TYPE } from '@components/top-widget-panel/constants';
import * as types from './types';

export const initialState = {
  type: SUMMARY_PANEL_TYPE.SPI,
  widgets: DEFAULT_WIDGETS.SPI,
};

const summaryWidgets = (state = initialState, action) => {
  switch (action.type) {
    case APPLY_PRESET_VIEW:
      return action.view.summaryWidgets ? { ...action.view.summaryWidgets } : state;
    case types.RESET: {
      return initialState;
    }

    case types.SET_SUMMARY_WIDGETS: {
      const {
        data: { widgets, type },
      } = action;
      return update(state, {
        type: {
          $set: type || SUMMARY_PANEL_TYPE.SPI,
        },
        widgets: {
          $set: getMergedWidgets(widgets, type),
        },
      });
    }

    default:
      return state;
  }
};

const getMergedWidgets = (
  widgets: Widget[] = [],
  type: string = SUMMARY_PANEL_TYPE.SPI,
): Widget[] => {
  const defaultWidgets = DEFAULT_WIDGETS[type];
  const newWidgetsArray: Widget[] = defaultWidgets.filter(
    ({ widgetKey: newWidgetKey }) => !widgets.find(({ widgetKey }) => widgetKey === newWidgetKey),
  );
  return [...widgets, ...newWidgetsArray];
};

export default summaryWidgets;
